import React from 'react';
import bonbon from '../img/2026/decor-bonbon.png';

const FestiveFrame = ({ children, variant = 'home' }) => (
    <div className={`festive-frame festive-frame-${variant}`}>
        {children}
        <img className="festive-decor festive-decor-bonbon" src={bonbon} alt="" />
    </div>
);

export default FestiveFrame;
